module.exports = __webpack_public_path__ + "static/media/executive3.d0a25769.webp";